import React from 'react';
import { IconButton, Tooltip, Badge } from '@mui/material';
import { Download } from '@mui/icons-material';
import { keyframes } from '@mui/system';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 212, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(0, 212, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 212, 255, 0);
  }
`;

/**
 * Shows a subtle download icon when a new version of the app is available.
 * Clicking it refreshes the page to load the new version.
 * 
 * @param {{ updateAvailable: boolean, onRefresh: () => void }} props
 */
const UpdateAvailableIndicator = ({ updateAvailable, onRefresh }) => {
  if (!updateAvailable) {
    return null;
  }

  return (
    <Tooltip title="Update available — click to refresh">
      <IconButton
        onClick={onRefresh}
        sx={{
          color: 'primary.main',
          borderRadius: '12px',
          marginRight: 1,
          animation: `${pulse} 2s ease-in-out infinite`,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'background.surface',
            transform: 'scale(1.1)',
          },
        }}
        aria-label="Update available"
      >
        <Badge
          variant="dot"
          color="primary"
          sx={{
            '& .MuiBadge-dot': {
              backgroundColor: '#00D4FF',
            },
          }}
        >
          <Download />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default UpdateAvailableIndicator;
